import { render, staticRenderFns } from "./AiInfoTable.vue?vue&type=template&id=90080d2c&scoped=true"
import script from "./AiInfoTable.vue?vue&type=script&lang=js"
export * from "./AiInfoTable.vue?vue&type=script&lang=js"
import style0 from "./AiInfoTable.vue?vue&type=style&index=0&id=90080d2c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "90080d2c",
  null
  
)

export default component.exports